var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlarmSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 26.774,
    viewBox: "0 0 20 26.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_144",
    "data-name": "\\uC0AC\\uAC01\\uD615 144",
    width: 20,
    height: 26.774,
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#19325f",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_309",
    "data-name": "\\uADF8\\uB8F9 309",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_308",
    "data-name": "\\uADF8\\uB8F9 308",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_175",
    "data-name": "\\uD328\\uC2A4 175",
    d: "M24.065,82.035a2.792,2.792,0,0,0,2.753-2.7H21.312a2.792,2.792,0,0,0,2.753,2.7",
    transform: "translate(-16.065 -59.261)",
    fill: "none",
    stroke: "#19325f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_176",
    "data-name": "\\uD328\\uC2A4 176",
    d: "M16,18.291v-.9a1.071,1.071,0,0,0-.2-.627l-.882-1.22a6.358,6.358,0,0,1-1.2-3.722V9.262a5.849,5.849,0,0,0-4.4-5.719V1.358a1.322,1.322,0,1,0-2.642,0V3.543a5.849,5.849,0,0,0-4.4,5.719v2.562a6.36,6.36,0,0,1-1.2,3.721L.2,16.77a1.064,1.064,0,0,0-.2.622v.9a.53.53,0,0,0,.522.537H15.478A.53.53,0,0,0,16,18.291",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#19325f",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmSmall);
export default __webpack_public_path__ + "static/media/icon-AlarmSmall.b209fec016623a62010a313e53db016d.svg";
export { ForwardRef as ReactComponent };